import React, { useState } from "react";
import SpriteButton from "./SpriteButton";
import VXButton from "./VXButton";

function PFPComponet({ image, number, setDisplaySelector }) {
  const [toggleMenu, setToggleMenu] = useState(true);
  async function toggleVX() {
    setDisplaySelector(1);
  }

  async function toggleTwoD() {
    setDisplaySelector(2);
  }

  async function handleToggleMenu() {
    setToggleMenu(!toggleMenu);
  }
  return (
    <>
      <div className="toggleDiv" onClick={handleToggleMenu}></div>
      <img src={image} alt={`YOLO Kidz #${number}`} />
      {toggleMenu && (
        <div className="slide-in">
          <VXButton toggleVX={toggleVX} />
          <SpriteButton toggleTwoD={toggleTwoD} />
        </div>
      )}
    </>
  );
}

export default PFPComponet;
